/**
 * DRAWER CORE
 * ---------------------------------------------------------------------------
 * Shared open/close behaviour for the `.content-block-slide` slide-out drawer,
 * extracted from no-color-v2.js.liquid so the same drawer can be used outside
 * the PDP (cart page, etc).
 *
 * Contract (unchanged from the original PDP implementation):
 *   - Trigger: any element with  data-drawer-btn="KEY"
 *   - Panel:   any element with  data-drawer="KEY"
 *   - Open adds `.show-drawer` to the matching panel and locks body scroll.
 *
 * Difference from the original: all handlers are DELEGATED via $(document).on,
 * so triggers/panels injected after page load (e.g. cart line controls) work.
 * The original cached $("[data-drawer-btn]") at script-eval time and silently
 * ignored anything added later.
 *
 * Events: every panel fires `drawer:open` / `drawer:close` on itself when its
 * state actually changes, and both bubble to `document`. A drawer that needs
 * to react (start a video, reset a form) listens for those instead of adding
 * its own open/close code here:
 *
 *   $(document).on('drawer:open', '[data-drawer="KEY"]', function () { … });
 *
 * Added for the size guide, which plays its video only while open. Before
 * this there was no way to know a drawer had closed — it can close from the
 * X, an outside click, Escape, or another drawer opening.
 *
 * Requires jQuery (loaded globally in layout/theme.liquid).
 */
(function () {
  'use strict';

  var OPEN_CLASS = 'show-drawer';

  function lockBodyScroll() {
    $('body').css('overflow', 'hidden');
  }

  function unlockBodyScroll() {
    $('body').css('overflow', '');
  }

  /**
   * The single place a panel's open state changes, so the events above fire
   * exactly once per real change no matter which path closed or opened it.
   */
  function setOpen($panel, open) {
    if ($panel.hasClass(OPEN_CLASS) === open) return;
    $panel.toggleClass(OPEN_CLASS, open);
    $panel.trigger(open ? 'drawer:open' : 'drawer:close');
  }

  function closeAllDrawers() {
    $('[data-drawer].' + OPEN_CLASS).each(function () {
      setOpen($(this), false);
    });
    unlockBodyScroll();
  }

  /**
   * Opens the drawer whose data-drawer matches `key`, closing any others.
   * Exposed on window so other scripts can open a drawer programmatically.
   */
  function openDrawer(key) {
    var $panels = $('[data-drawer]');
    var opened = false;

    $panels.each(function () {
      var $panel = $(this);
      var isTarget = String($panel.data('drawer')) === String(key);
      setOpen($panel, isTarget);
      if (isTarget) opened = true;
    });

    if (opened) {
      lockBodyScroll();
    } else {
      console.warn('[drawer-core] No drawer found for key:', key);
    }

    return opened;
  }

  // ---------------- Open ----------------
  $(document).on('click', '[data-drawer-btn]', function (e) {
    e.stopPropagation();
    openDrawer($(this).data('drawer-btn'));
  });

  // ---------------- Close: X button ----------------
  $(document).on('click', '.closeBtn', function () {
    setOpen($(this).closest('[data-drawer]'), false);
    unlockBodyScroll();
  });

  // ---------------- Close: click outside the panel ----------------
  // Only runs while a drawer is actually open, so it does not fire on every
  // page click the way the original document-level handler did.
  $(document).on('click', function (e) {
    var $open = $('[data-drawer].' + OPEN_CLASS);
    if (!$open.length) return;

    // A click on a drawer trigger must not immediately close the drawer it
    // just opened. The original code relied on stopPropagation for this, which
    // only worked because the handler was bound directly to each trigger;
    // now that opening is delegated at the document level, both handlers run
    // on the same node and stopPropagation no longer separates them.
    if (e.target.closest && e.target.closest('[data-drawer-btn]')) return;

    var $container = $open.find('.custom-drawer-container');
    if (!$container.is(e.target) && $container.has(e.target).length === 0) {
      closeAllDrawers();
    }
  });

  // ---------------- Close: Escape ----------------
  $(document).on('keydown', function (e) {
    if (e.key === 'Escape') closeAllDrawers();
  });

  window.DrawerCore = {
    open: openDrawer,
    closeAll: closeAllDrawers
  };
})();
